import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const New = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='New' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,1 L12,23 M2,6 L22,18 M22.0000001,6 L2.00000008,18' />
  </StyledIcon>
);
